import React from "react";
import { useQuery } from "react-query";
import { GetCacheKey } from "../../services/common/utils";
import BannersComponent from "../common/banner";
import TabsComponent from "../common/tabs";
import Loadingcomponent from "../loader/loadingcomponent";
import ErrorMessage from "../messaging/errormessage";
import { Banner } from "../loader/skeletons";

const PassportCountriesBanner = ({ pmsitem, extraData, isRoamingJourney }) => {
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid), {}], {
    retry: false,
    retryOnMount: false,
  });
  if (isLoading || isFetching) {
    // return <Loadingcomponent message={"Loading"} />;
    return <Banner height='190px' />
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={"Invalid"} />;
  }
  const bannerData = {
    name:
      data?.response?.length && data?.response[0]?.banners?.length
        ? data?.response[0]?.banners[0]?.title
        : "",
    image:
      data?.response?.length && data?.response[0]?.banners?.length
        ? data?.response[0]?.banners[0]?.path
        : "",
    bgcolor: extraData?.bgcolor,
  };
  return (
    <div>
      {isRoamingJourney ? 
      <BannersComponent type={5} data={bannerData} isRoamingJourney={isRoamingJourney}></BannersComponent>
      :
      <BannersComponent type={1} data={bannerData} isRoamingJourney={isRoamingJourney}></BannersComponent>
      }
    </div>
  );
};

export default PassportCountriesBanner;
